<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
    <g id="Facebook">
      <g id="Icon-8" data-name="Icon">
        <path
          d="M19.024,4.917A9.933,9.933,0,1,0,4.976,18.964,9.933,9.933,0,0,0,19.024,4.917Zm-.707,13.34A8.863,8.863,0,0,1,13,20.814V14.263h1.873a1,1,0,0,0,0-2H13V9.523a1,1,0,0,1,1-1h1.2a1,1,0,0,0,0-2H13.5a2.5,2.5,0,0,0-2.5,2.5v3.24H9.133a1,1,0,0,0,0,2H11v6.551a8.929,8.929,0,0,1-5.32-15.19A8.933,8.933,0,0,1,18.317,18.257Z"
        />
      </g>
    </g>
  </svg>
</template>
